import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowBottomItemTagsProps as Props } from './types';
import type { Hashtag } from '../../../types/recruitmentShow';
import { showRecruitmentPageHashtags } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [hashtags, setHashtags] = useState<Hashtag[]>([])

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageHashtags(props.recruitmentId);
        setHashtags(response.hashtags)
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  return (
    <Presentation
      {...props}
      hashtags={hashtags}
    />
  );
};
